export default [
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/adm/modules/Home.vue')
  },
]